import React, { useState } from "react"
import { useDispatch } from "react-redux"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { deleteContact } from "../../../../actions/Organizations/Enterprise"
import { openAppMessageSnackBar } from "../../../../actions/Utils/app"

const DeleteContactConfirmModal = ({ open, onClose, enterpriseId, contact }) => {
  const dispatch = useDispatch()
  const [isSubmitting, setSubmitting] = useState(false)
  const [serverError, setServerError] = useState(null)

  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ")

  const handleClose = () => {
    if (isSubmitting) return
    setServerError(null)
    onClose()
  }

  const handleConfirm = async () => {
    setSubmitting(true)
    setServerError(null)
    try {
      await dispatch(deleteContact(enterpriseId, contact.id))
      onClose()
      dispatch(openAppMessageSnackBar(`Contact « ${fullName} » supprimé.`))
    } catch {
      setServerError("Une erreur est survenue, veuillez réessayer")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} sx={sx.dialog}>
      <DialogTitle sx={sx.title}>
        Souhaitez-vous supprimer ce contact ?
        <IconButton onClick={handleClose} disabled={isSubmitting} sx={sx.closeBtn}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={sx.content}>
        <Typography variant="body2" sx={{ color: "text.primary", fontSize: 14, lineHeight: 1.5 }}>
          Le contact <Box component="strong" sx={{ fontWeight: 500 }}>{fullName}</Box> ({contact.email}) sera
          supprimé définitivement de cette entreprise. Cette action est irréversible.
        </Typography>
      </DialogContent>

      {serverError && (
        <Typography sx={sx.serverError}>{serverError}</Typography>
      )}

      <DialogActions sx={sx.actions}>
        <Button variant="text" onClick={handleClose} disabled={isSubmitting}>
          Annuler
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Suppression…" : "Supprimer"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const sx = {
  dialog: {
    "& .MuiDialog-paper": {
      width: 560,
      maxWidth: 560,
      borderRadius: "12px",
    },
  },
  title: {
    px: 4,
    pt: 3,
    pb: 1,
    fontSize: 20,
    fontWeight: 400,
    pr: 7,
    marginBottom: "30px !important",
  },
  closeBtn: {
    position: "absolute",
    right: 16,
    top: 16,
    color: "text.secondary",
  },
  content: {
    px: 4,
    pt: 1,
    pb: 2,
  },
  serverError: {
    px: 4,
    pb: 1,
    fontSize: 14,
    color: "error.main",
  },
  actions: {
    px: 4,
    py: 2.5,
    justifyContent: "space-between",
    gap: 1.5
  },
}

export default DeleteContactConfirmModal
